// Hero.controller.jsx
import { useEffect, useState } from 'react';

import { desktopHeroData, mobileHeroData } from './HeroModel.js';

export const useHeroController = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slides = isMobile ? mobileHeroData : desktopHeroData;

  useEffect(() => {
    if (isDragging) return;
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentSlide, isDragging]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    setDragOffset(0);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    setDragOffset(0);
  };

  const onStart = (e) => {
    setIsDragging(true);
    setStartX(e.pageX || e.touches[0].pageX);
  };

  const onMove = (e) => {
    if (!isDragging) return;
    const currentX = e.pageX || e.touches[0].pageX;
    setDragOffset(currentX - startX);
  };

  const onEnd = () => {
    if (!isDragging) return;

    // Se arrastou mais de 100px, troca o slide
    if (dragOffset < -100) nextSlide();
    else if (dragOffset > 100) prevSlide();

    setIsDragging(false);
    setDragOffset(0);
  };

  return {
    slides,
    currentSlide,
    dragOffset,
    isDragging,
    onStart,
    onMove,
    onEnd,
    nextSlide,
    prevSlide,
  };
};
